<template>
  <div class="account-delete-container">
    <div class="panel">
      <h2>注销账号</h2>

      <div v-if="pendingDeletion" class="status-card pending">
        <div class="status-icon">⏳</div>
        <div class="status-title">注销申请已提交</div>
        <div class="status-desc">
          您的账号注销申请已提交，进入 <strong>7 天冷静期</strong>。
          冷静期内您可以登录并撤销申请，冷静期满后系统将自动执行最终注销。
        </div>
        <button class="btn-revert" :disabled="revertLoading" @click="onRevert">
          {{ revertLoading ? '处理中...' : '撤销注销申请' }}
        </button>
      </div>

      <div v-else class="delete-form">
        <div class="warning-box">
          <div class="warning-title">注销账号前，请确认以下事项：</div>
          <div class="warning-list">
            <div class="warning-item">1. 您的余额、积分将被清零，且不可恢复</div>
            <div class="warning-item">2. 您的个人资料（头像、昵称等）将被清除</div>
            <div class="warning-item">3. 您的购物车、收货地址、收藏/关注/点赞等数据将被删除</div>
            <div class="warning-item">4. 您已发布的帖子、作品将被下架，但内容保留并显示为"已注销用户"</div>
            <div class="warning-item">5. 您与第三方的授权绑定（微信等）将被解除</div>
            <div class="warning-item">6. 您未完成的订单将被自动取消</div>
            <div class="warning-item">7. 您开通的店铺将被关闭</div>
          </div>
        </div>

        <div class="cooling-notice">
          <div class="notice-icon">📋</div>
          <div class="notice-text">
            根据相关规定，提交注销申请后将有 <strong>7 天冷静期</strong>。
            冷静期内您可以随时登录并撤销申请；冷静期满后系统将自动执行注销，届时所有数据将无法恢复。
          </div>
        </div>

        <div class="action-box">
          <button class="btn-cancel" :disabled="deleteLoading" @click="onConfirmDelete">
            {{ deleteLoading ? '提交中...' : '提交注销申请' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CancelAccount, CancelDeletion } from "@/api/index";
import { mapState } from "vuex";

export default {
  name: "AccountDelete",
  data() {
    return {
      deleteLoading: false,
      revertLoading: false,
    };
  },
  computed: {
    ...mapState(["userInfo"]),
    pendingDeletion() {
      return this.userInfo && this.userInfo.status == -2;
    },
  },
  methods: {
    async onConfirmDelete() {
      if (this.deleteLoading) return;
      try {
        this.deleteLoading = true;
        await CancelAccount({});
        this.$layer.msg("注销申请已提交，7天冷静期内可登录撤销");
        try {
          await this.$store.dispatch("getUser");
        } catch (e) {
          // 刷新用户信息失败不影响主流程
          console.warn('刷新用户信息失败:', e);
        }
      } catch (e) {
        this.$layer.msg(e.msg || "提交失败");
      } finally {
        this.deleteLoading = false;
      }
    },
    async onRevert() {
      if (this.revertLoading) return;
      try {
        this.revertLoading = true;
        await CancelDeletion({});
        this.$layer.msg("已撤销注销申请");
        try {
          await this.$store.dispatch("getUser");
        } catch (e) {
          // 刷新用户信息失败不影响主流程
          console.warn('刷新用户信息失败:', e);
        }
      } catch (e) {
        this.$layer.msg(e.msg || "撤销失败");
      } finally {
        this.revertLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.account-delete-container {
  padding: 30px;
  max-width: 800px;
  margin: 0 auto;

  .panel {
    background: #fff;
    border-radius: 8px;
    padding: 30px;

    h2 {
      font-size: 20px;
      font-weight: bold;
      color: #333;
      margin-bottom: 24px;
      padding-bottom: 16px;
      border-bottom: 1px solid #f0f0f0;
    }
  }

  .status-card {
    text-align: center;
    padding: 40px 20px;

    &.pending {
      .status-icon {
        font-size: 48px;
        margin-bottom: 16px;
      }
      .status-title {
        font-size: 20px;
        font-weight: bold;
        color: #e6a23c;
        margin-bottom: 12px;
      }
      .status-desc {
        font-size: 14px;
        color: #666;
        line-height: 1.8;
        margin-bottom: 24px;
      }
    }
  }

  .warning-box {
    background: #fff5f5;
    border: 1px solid #ffd7d7;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;

    .warning-title {
      font-size: 16px;
      font-weight: bold;
      color: #e4393c;
      margin-bottom: 12px;
    }

    .warning-list {
      .warning-item {
        font-size: 14px;
        color: #666;
        line-height: 2;
        padding-left: 8px;
      }
    }
  }

  .cooling-notice {
    display: flex;
    align-items: flex-start;
    background: #f0f9ff;
    border: 1px solid #b3e5ff;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 24px;

    .notice-icon {
      font-size: 24px;
      margin-right: 12px;
      flex-shrink: 0;
    }

    .notice-text {
      font-size: 14px;
      color: #555;
      line-height: 1.8;
    }
  }

  .action-box {
    text-align: center;
  }

  .btn-cancel {
    background: #fff;
    color: #e4393c;
    border: 1px solid #e4393c;
    border-radius: 6px;
    padding: 12px 48px;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover:not(:disabled) {
      background: #fff5f5;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  .btn-revert {
    background: #fff;
    color: #e4393c;
    border: 1px solid #e4393c;
    border-radius: 6px;
    padding: 12px 36px;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover:not(:disabled) {
      background: #fff5f5;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
}
</style>
